<div  class="confirm-container">
  <mat-card class="confirm-card">
    <mat-card-header>
      <mat-icon class="icon">check_circle</mat-icon>
      <h2>Payment Confirmed</h2>
    </mat-card-header>
    <mat-card-content>
      <p>Your payment has been successfully processed. Thank you for your purchase!</p>
      <div  class="confirmation-details" style="font-family:monospace;">
        <p><strong>OrderID:</strong> {{ confirmationData.orderId ||'-' }}</p>
        <p><strong>Amount :</strong> {{ confirmationData.amount?('₹ '+confirmationData.amount):'-'}}</p>
        <p><strong>Status :</strong> {{ confirmationData.status ||'-'}}</p>
      </div>
      <div class="timer-container">
        <p>Go Back in {{ countdown }} seconds</p>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <!-- <button mat-raised-button color="accent" (click)="viewReceipt()">View Receipt</button> -->
      <button mat-flat-button style="background-color: #155724; color: white;" (click)="goBack()">Go Back</button>
    </mat-card-actions>
  </mat-card>
</div>

<!-- <form #f method="post" action="http://localhost:4200/payment/payment/cca/confirm">
<input type="text" id="encResp" name="encResp" >


<input type="submit" value="submit">

</form> -->
